import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { H2RButton } from "../../imports";
import { sToStringFormatted } from "../helpers/time";
import { audioTypesDefinitions } from "../../imports";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	return (
		<>
			<H2RInput
				label="Name"
				placeholder="Audio name"
				value={cue.name}
				onChange={(value) => {
					onUpdate({ name: value });
				}}
			/>

			{/* <H2RSelect
				selected={cue.backgroundFit || "cover"}
				label="Video size"
				options={[
					{
						label: "Grow to fill screen",
						value: "cover",
					},
					{
						label: "Shrink to fit",
						value: "contain",
					},
				]}
				onChange={(value) => {
					return onUpdate({ backgroundFit: value });
				}}
			/> */}

			<H2RSelect
				selected={cue.filename}
				label="Audio file"
				options={
					media.length === 0
						? [
								{
									label: "Add audio in the Media tab",
									value: ``,
									disabled: true,
								},
						  ]
						: [
								...media
									.filter((item) =>
										audioTypesDefinitions.includes(item?.mimetype)
									)
									.map((item) => {
										return {
											label: item.originalname,
											value: item.filename,
										};
									}),
						  ]
				}
				onChange={(value) => {
					return onUpdate({ filename: value });
				}}
			/>

			{/* <VideoPreview video={cue.filename} /> */}

			<span className=" text-gray-500 tracking-wide font-semibold text-xs">
				Controls
			</span>
			<div className="flex space-x-2">
				<H2RButton
					checked={cue.loop || false}
					text={cue.loop ? "Looping" : "Loop"}
					colour={cue.loop ? "main" : "dark"}
					icon={faRefresh}
					size="small"
					onClick={() => {
						return onUpdate({ loop: !cue.loop });
					}}
				/>
			</div>
			<H2RInput
				type="range"
				label="Volume"
				colour="dark"
				value={cue.volume || 100}
				labelValue={cue.volume || 100}
				max={100}
				min={0}
				step={1}
				onChange={(change) => {
					onUpdate({ volume: change });
				}}
			/>

			<span className=" text-gray-500 tracking-wide font-semibold text-xs">
				Duration
			</span>
			<div className="text-sm flex space-x-2 font-mono">
				<span>{sToStringFormatted(parseFloat(cue.currentTime))}</span>
				<span className="text-gray-600">/</span>
				<span>{sToStringFormatted(parseInt(cue.length))}</span>
			</div>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	const endingSoon = cue.currentTime >= cue.length - 5;
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">{cue.name || "Audio"}</span>
			<span className="font-mono">
				<span className="text-gray-100 opacity-40 px-2">•</span>
				{cue.currentTime !== 0 && (
					<span
						className={`text-sm ${
							endingSoon ? "text-red-400" : "text-gray-300"
						}`}
					>
						<span>{sToStringFormatted(parseFloat(cue.currentTime))}</span>
						<span className="text-gray-100 opacity-40 px-2">/</span>
					</span>
				)}
				<span
					className={` text-sm ${
						endingSoon ? "text-red-400" : "text-gray-300"
					}`}
				>
					<span>{sToStringFormatted(parseInt(cue.length))}</span>
				</span>
			</span>
		</div>
	);
};
